import { AuthDiagnostics } from '@/components/debug/AuthDiagnostics';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AuthDebugPage = () => {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center space-x-4">
          <Button variant="outline" size="sm" asChild>
            <Link to="/admin">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Admin
            </Link>
          </Button>
          <div>
            <h1 className="text-2xl font-bold">Authentication Debug</h1>
            <p className="text-muted-foreground">
              Debug JWT token transmission and authentication issues
            </p>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>JWT Token Diagnostics</CardTitle>
            <CardDescription>
              Use this tool to diagnose authentication issues, particularly JWT token transmission problems.
              This helps resolve cases where auth.uid() returns null in RLS policies.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <AuthDiagnostics />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};